import { Autocomplete, AutocompleteRenderInputParams, FilledInput, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { GridSearchIcon, SearchFilterIcon, SearchIcon } from '../../icon';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';
import SelectChannelSideBarComponent from '../channels/select-channel-side-bar-component';

interface Props {
    handleSearch: (value: string) => void
    handlePage: (page) => void;
    pages: any[];
    activePage: any;
    HideFilter?:boolean;
    handleFilter?: (e) => void
    ChannelOptions?: any
    handleChannelOptions?: (values) => void;
    SelectChannel?: boolean;
}

const ConversationCardsHeader = (props: Props) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    console.log(props.activePage)

    return (
        <div className='d-flex w-p-100 justify-around align-center'>

            {props.SelectChannel && <div className='w-5 h-5 d-flex justify-center align-center mr-1'>
                <SelectChannelSideBarComponent Options={props.ChannelOptions} handleSidebarWidth={() => { }} handleOptions={props.handleChannelOptions} />
            </div>
            }

            <Autocomplete
                size="small"
                className={`flex-1 mx-1 c-pointer d-flex justify-center h-p-100`}
                value={props.activePage}
                disableClearable
                onChange={(event, value) => { props.handlePage(value) }}
                options={props.pages}
                getOptionLabel={(option) => option.Label || ""}
                classes={{
                    option: "custom-option h5-medium",
                    input: `color-text-field-font h4-regular d-flex justify-center c-pointer`
                }}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        placeholder="Page Name"
                        required
                        variant="standard"
                        size='small'
                        onKeyDown={(e) => (e.preventDefault())}
                        inputProps={{ ...params.inputProps, readOnly: true }}
                        className=''

                        InputLabelProps={{
                            shrink: true,
                        }} />}
            />
            <FilledInput
                inputProps={{
                    tabIndex: 4,
                    "data-arrow-index": 2000,
                }}
                // value={SearchText}
                fullWidth
                className="m-auto filled-search-input bg-color-side-bar h5-medium flex-1 h-p-100 mr-1"
                placeholder={"Search..."}
                onChange={(e) => props.handleSearch(e.target.value)}
                startAdornment={<InputAdornment position="start">
                    <GridSearchIcon />
                </InputAdornment>}
                // endAdornment={<InputAdornment position="start">
                //     <SearchFilterIcon className='c-pointer' onClick={(e) => props.handleFilter(e)} />
                // </InputAdornment>}
                disableUnderline
            />
        </div>
    )
}

export default ConversationCardsHeader